export default "__VITE_ASSET__f5f79789__"